const imports = require("../../../../lib");
module.exports = imports.stronachgroup.first.racehorse360;

const grpc = {};
grpc.web = require("grpc-web");

module.exports.RaceServiceSimpleClient = function RaceServiceSimpleClient(
  hostname,
  credentials,
  options
) {
  if (!options) options = {};
  options["format"] = "text";

  this.client_ = new grpc.web.GrpcWebClientBase(options);
  this.hostname_ = hostname;
  this.credentials_ = credentials;
  this.options_ = options;

  this.listRace = this.listRace.bind(this);
  this.listRaceHistories = this.listRaceHistories.bind(this);
  this.listRaceRestrictions = this.listRaceRestrictions.bind(this);
  this.listUpcomingRaces = this.listUpcomingRaces.bind(this);
};
const methodInfo_RaceService_ListRace = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.RaceService/ListRace",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.ListRacesRequest,
  imports.stronachgroup.first.racehorse360.ListRacesResponse,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.ListRacesResponse.decode
);
module.exports.RaceServiceSimpleClient.prototype.listRace = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.ListRacesRequest.create(request);
  return this.client_.unaryCall(
    this.hostname_ + "/stronachgroup.first.racehorse360.RaceService/ListRace",
    message,
    metadata || {},
    methodInfo_RaceService_ListRace
  );
};
const methodInfo_RaceService_ListRaceHistories = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.RaceService/ListRaceHistories",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.ListRaceHistoriesRequest,
  imports.stronachgroup.first.racehorse360.ListRaceHistoriesResponse,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.ListRaceHistoriesResponse.decode
);
module.exports.RaceServiceSimpleClient.prototype.listRaceHistories = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.ListRaceHistoriesRequest.create(
      request
    );
  return this.client_.unaryCall(
    this.hostname_ +
      "/stronachgroup.first.racehorse360.RaceService/ListRaceHistories",
    message,
    metadata || {},
    methodInfo_RaceService_ListRaceHistories
  );
};
const methodInfo_RaceService_ListRaceRestrictions =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.RaceService/ListRaceRestrictions",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ListRaceRestrictionsRequest,
    imports.stronachgroup.first.racehorse360.ListRaceRestrictionsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListRaceRestrictionsResponse.decode
  );
module.exports.RaceServiceSimpleClient.prototype.listRaceRestrictions =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ListRaceRestrictionsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.RaceService/ListRaceRestrictions",
      message,
      metadata || {},
      methodInfo_RaceService_ListRaceRestrictions
    );
  };
const methodInfo_RaceService_ListUpcomingRaces = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.RaceService/ListUpcomingRaces",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.ListUpcomingRacesRequest,
  imports.stronachgroup.first.racehorse360.ListUpcomingRacesResponse,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.ListUpcomingRacesResponse.decode
);
module.exports.RaceServiceSimpleClient.prototype.listUpcomingRaces = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.ListUpcomingRacesRequest.create(
      request
    );
  return this.client_.unaryCall(
    this.hostname_ +
      "/stronachgroup.first.racehorse360.RaceService/ListUpcomingRaces",
    message,
    metadata || {},
    methodInfo_RaceService_ListUpcomingRaces
  );
};
